var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThreatLandscape = function SvgThreatLandscape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#threat-landscape_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.625 1.75v.875h1.131L8.57 4.813l.618.618 2.188-2.187v1.131h.875V1.75zM4.375 1.75v.875H3.244L5.43 4.813l-.618.618-2.188-2.187v1.131H1.75V1.75zM8.75 2.188 7 .438l-1.75 1.75.619.618.694-.693v2.7h.875v-2.7l.693.693zM9.625 12.25v-.875h1.131L8.57 9.188l.618-.62 2.188 2.188V9.625h.875v2.625zM4.375 12.25v-.875H3.244L5.43 9.188l-.618-.62-2.188 2.188V9.625H1.75v2.625zM8.75 11.813 7 13.563l-1.75-1.75.619-.62.694.694v-2.7h.875v2.7l.693-.693zM2.188 5.25.438 7l1.75 1.75.618-.619-.693-.694h2.7v-.875h-2.7l.693-.693zM11.813 5.25 13.563 7l-1.75 1.75-.62-.619.694-.694h-2.7v-.875h2.7l-.693-.693z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "threat-landscape_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgThreatLandscape;